{"errno":-2,"code":"ENOENT","syscall":"open","path":"/usr/local/google/home/chholland/repos/firebase-TMP/packages/auth/dist/[synthetic:es6/util/arrayiterator]"}